import {
  FETCH_STOCK_RETURNS_REQUEST,
  FETCH_STOCK_RETURNS_SUCCESS,
  FETCH_STOCK_RETURNS_FAILURE,
  CREATE_STOCK_RETURN_REQUEST,
  CREATE_STOCK_RETURN_SUCCESS,
  CREATE_STOCK_RETURN_FAILURE,
  UPDATE_STOCK_RETURN_REQUEST,
  UPDATE_STOCK_RETURN_SUCCESS,
  UPDATE_STOCK_RETURN_FAILURE,
  PROCESS_STOCK_RETURN_REQUEST,
  PROCESS_STOCK_RETURN_SUCCESS,
  PROCESS_STOCK_RETURN_FAILURE,
  DELETE_STOCK_RETURN_REQUEST,
  DELETE_STOCK_RETURN_SUCCESS,
  DELETE_STOCK_RETURN_FAILURE
} from '../../types/stockReturn/stockReturnTypes';

const initialState = {
  stockReturns: [],
  loading: false,
  error: null
};

const stockReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STOCK_RETURNS_REQUEST:
    case CREATE_STOCK_RETURN_REQUEST:
    case UPDATE_STOCK_RETURN_REQUEST:
    case PROCESS_STOCK_RETURN_REQUEST:
    case DELETE_STOCK_RETURN_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STOCK_RETURNS_SUCCESS:
      return { ...state, loading: false, stockReturns: action.payload };
    case CREATE_STOCK_RETURN_SUCCESS:
      return { ...state, loading: false, stockReturns: [action.payload, ...state.stockReturns] };
    case UPDATE_STOCK_RETURN_SUCCESS:
      return { ...state, loading: false };
    case PROCESS_STOCK_RETURN_SUCCESS:
      return { ...state, loading: false };
    case DELETE_STOCK_RETURN_SUCCESS:
      return { ...state, loading: false, stockReturns: state.stockReturns.filter(r => r.id !== action.payload) };
    case FETCH_STOCK_RETURNS_FAILURE:
    case CREATE_STOCK_RETURN_FAILURE:
    case UPDATE_STOCK_RETURN_FAILURE:
    case PROCESS_STOCK_RETURN_FAILURE:
    case DELETE_STOCK_RETURN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default stockReturnReducer; 